import { createContext, useMemo } from "react";
import { createTheme } from "@mui/material/styles";
import { useSelector, useDispatch } from "react-redux";
import { toggleThemeMode } from "./state";
// color design tokens export
export const tokens = (mode) => ({
  ...(mode === "dark"
    ? {
        whiteAccent: {
          50: "#292929",
          100: "#464646",
          200: "#525252",
          300: "#7c7c7c",
          400: "#989898",
          500: "#bdbdbd",
          600: "#656565",
          700: "#dcdcdc",
          800: "#efefef",
          900: "#3d3d3d",
          950: "#fafafa",
        },
        desert: {
          50: "#fbf7ef",
          100: "#f4e8d1",
          200: "#e9cf9e",
          300: "#ddb26c",
          400: "#d59b4a",
          500: "#cb7e35",
          600: "#b1602b",
          700: "#964727",
          800: "#7a3a26",
          900: "#653122",
          950: "#39180f",
        },
        gov: {
          50: "#eceef8",
          100: "#d2d6f0",
          200: "#a5afe1",
          300: "#7888d2",
          400: "#4b60c3",
          500: "#273c7d",
          600: "#1f3066",
          700: "#17234f",
          800: "#0f1738",
          900: "#080b1f",
          950: "#d2d6f0",
        },
        pacificBlue: {
          50: "#ecfeff",
          100: "#cffafe",
          200: "#a6f1fb",
          300: "#68e6f8",
          400: "#24d1ec",
          500: "#08b4d2",
          600: "#0a99bd",
          700: "#0f728f",
          800: "#165d74",
          900: "#174d62",
          950: "#083344",
        },
        black: {
          50: "#000000",
          100: "#3d3d3d",
          200: "#454545",
          300: "#4f4f4f",
          400: "#5d5d5d",
          500: "#6d6d6d",
          600: "#888888",
          700: "#b0b0b0",
          800: "#d1d1d1",
          900: "#e7e7e7",
          950: "#f6f6f6",
        },
        grey: {
          100: "#e0e0e0",
          200: "#c2c2c2",
          300: "#a3a3a3",
          400: "#858585",
          500: "#666666",
          600: "#525252",
          700: "#3d3d3d",
          800: "#292929",
          900: "#141414",
        },
        primary: {
          100: "#d0d1d5",
          200: "#a1a4ab",
          300: "#727681",
          400: "#1F2A40",
          500: "#141b2d",
          600: "#101624",
          700: "#0c101b",
          800: "#080b12",
          900: "#040509",
        },
        greenAccent: {
          100: "#dbf5ee",
          200: "#b7ebde",
          300: "#94e2cd",
          400: "#70d8bd",
          500: "#4cceac",
          600: "#3da58a",
          700: "#2e7c67",
          800: "#1e5245",
          900: "#0f2922",
        },
        redAccent: {
          100: "#f8dcdb",
          200: "#f1b9b7",
          300: "#e99592",
          400: "#e2726e",
          500: "#db4f4a",
          600: "#af3f3b",
          700: "#832f2c",
          800: "#58201e",
          900: "#2c100f",
        },
        blueAccent: {
          100: "#e1e2fe",
          200: "#c3c6fd",
          300: "#a4a9fc",
          400: "#868dfb",
          500: "#6870fa",
          600: "#535ac8",
          700: "#3e4396",
          800: "#2a2d64",
          900: "#151632",
        },
      }
    : {
        whiteAccent: {
          50: "#fafafa",
          100: "#efefef",
          200: "#dcdcdc",
          300: "#bdbdbd",
          400: "#989898",
          500: "#7c7c7c",
          600: "#656565",
          700: "#525252",
          800: "#464646",
          900: "#3d3d3d",
          950: "#292929",
        },
        desert: {
          50: "#fbf7ef",
          100: "#f4e8d1",
          200: "#e9cf9e",
          300: "#ddb26c",
          400: "#d59b4a",
          500: "#cb7e35",
          600: "#b1602b",
          700: "#964727",
          800: "#7a3a26",
          900: "#653122",
          950: "#39180f",
        },
        gov: {
          50: "#080b1f",
          100: "#0f1738",
          200: "#17234f",
          300: "#1f3066",
          400: "#233979",
          500: "#273c7d",
          600: "#4b60c3",
          700: "#7888d2",
          800: "#a5afe1",
          900: "#d2d6f0",
          950: "#7888d2",
        },
        black: {
          50: "#f6f6f6",
          100: "#e7e7e7",
          200: "#d1d1d1",
          300: "#b0b0b0",
          400: "#888888",
          500: "#6d6d6d",
          600: "#5d5d5d",
          700: "#4f4f4f",
          800: "#454545",
          900: "#3d3d3d",
          950: "#000000",
        },
        grey: {
          100: "#141414",
          200: "#292929",
          300: "#3D3D3D",
          400: "#525252",
          500: "#666666",
          600: "#858585",
          700: "#A3A3A3",
          800: "#C2C2C2",
          900: "#E0E0E0",
        },
        primary: {
          100: "#FCFCFC",
          200: "#E0E0E0",
          300: "#D1D1D1",
          400: "#FCFCFC", // manually changed
          500: "#2C92B5",
          600: "#1F2A40",
          700: "#67C5D7",
          800: "#A1A4AB",
          900: "#F2F0F0",
        },
        greenAccent: {
          100: "#0F2922",
          200: "#1E5245",
          300: "#2E7C67",
          400: "#3DA58A",
          500: "#4CCEAC",
          600: "#70D8BD",
          700: "#94E2CD",
          800: "#B7EBDE",
          900: "#DBF5EE",
        },
        redAccent: {
          100: "#2C100F",
          200: "#58201E",
          300: "#832F2C",
          400: "#AF3F3B",
          500: "#DB4F4A",
          600: "#E2726E",
          700: "#E99592",
          800: "#F1B9B7",
          900: "#F8DCDB",
        },
        blueAccent: {
          100: "#151632",
          200: "#2A2D64",
          300: "#3E4396",
          400: "#67C5D7",
          500: "#6870FA",
          600: "#868DFB",
          700: "#A4A9FC",
          800: "#C3C6FD",
          900: "#E1E2FE",
        },
        pacificBlue: {
          50: "#ecfeff",
          100: "#cffafe",
          200: "#a6f1fb",
          300: "#68e6f8",
          400: "#24d1ec",
          500: "#08b4d2",
          600: "#0a99bd",
          700: "#0f728f",
          800: "#165d74",
          900: "#174d62",
          950: "#083344",
        },
      }),
});
// mui theme settings
export const themeSettings = (mode) => {
  const colors = tokens(mode);
  return {
    palette: {
      mode: mode,
      ...(mode === "dark"
        ? {
            // palette values for dark mode
            primary: {
              main: colors.primary[500],
            },
            secondary: {
              main: colors.gov[500],
            },
            neutral: {
              dark: colors.grey[700],
              main: colors.grey[500],
              light: colors.grey[100],
            },
            background: {
              default: colors.primary[500],
            },
          }
        : {
            // palette values for light mode
            primary: {
              main: colors.primary[100],
            },
            secondary: {
              main: colors.gov[500],
            },
            neutral: {
              dark: colors.grey[700],
              main: colors.grey[500],
              light: colors.grey[100],
            },
            background: {
              default: "#F2F0F0",
            },
          }),
    },
    typography: {
      fontFamily: ["Source Sans Pro", "sans-serif"].join(","),
      fontSize: 13,
      h1: {
        fontFamily: ["Source Sans Pro", "sans-serif"].join(","),
        fontSize: 40,
      },
      h2: {
        fontFamily: ["Source Sans Pro", "sans-serif"].join(","),
        fontSize: 32,
      },
      h3: {
        fontFamily: ["Source Sans Pro", "sans-serif"].join(","),
        fontSize: 24,
      },
      h4: {
        fontFamily: ["Source Sans Pro", "sans-serif"].join(","),
        fontSize: 20,
      },
      h5: {
        fontFamily: ["Source Sans Pro", "sans-serif"].join(","),
        fontSize: 16,
      },
      h6: {
        fontFamily: ["Source Sans Pro", "sans-serif"].join(","),
        fontSize: 14,
      },
    },
    components: {
      MuiFormLabel: {
        styleOverrides: {
          root: {
            ...(mode === "dark" && {
              color: colors.grey[300],
              "&.Mui-focused": {
                color: colors.grey[100],
              },
              "&.Mui-disabled": {
                color: colors.grey[500],
              },
            }),
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            ...(mode === "dark" && {
              backgroundColor: colors.primary[400],
              color: colors.grey[100],
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: colors.grey[600],
              },
              "&:hover:not(.Mui-disabled) .MuiOutlinedInput-notchedOutline": {
                borderColor: colors.grey[400],
              },
              "&.Mui-disabled": {
                backgroundColor: colors.primary[700],
                WebkitTextFillColor: colors.grey[500],
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.grey[700],
                },
              },
            }),
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            ...(mode === "dark" && {
              color: colors.grey[300],
              "&.Mui-focused": {
                color: colors.grey[100],
              },
              "&.Mui-disabled": {
                color: colors.grey[500],
              },
            }),
          },
        },
      },
    },
  };
};
// context for color mode
export const ColorModeContext = createContext({
  toggleColorMode: () => {},
});

export const useMode = () => {
  const dispatch = useDispatch();
  const themeMode = useSelector((state) => state.themeMode);

  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => dispatch(toggleThemeMode()),
    }),
    [dispatch],
  );

  const theme = useMemo(() => createTheme(themeSettings(themeMode)), [themeMode]);

  return [theme, colorMode];
};
